import { put, take, race, call } from 'redux-saga/effects';
import { delay } from '../utils.js';

import {
    showSiteMessage,
    CLOSE_SITE_MESSAGE,
    resetSiteMessage
} from '../actions/siteMessageActions';

import { hideLoaderSaga } from '../sagas/loaderSagas';

export function* siteMessageSaga(message = '', route, error) {
    yield call(hideLoaderSaga);
    yield put(showSiteMessage(message, route));
    const { close, timeout } = yield race({ close: take(), timeout: call(delay, 5000) });
    yield put(resetSiteMessage());
}
